import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthService } from './core/auth.service';
import { NavigationStart, Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { Subscription } from 'rxjs';
import { ApplicationUserService } from './core/applicationuser.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  {
  title = 'sds-frontend';

  constructor(
    public authService: AuthService, 

  ) {

  }





}
